var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSecured(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.668,
    height: 25.821,
    viewBox: "0 0 19.668 25.821",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.1,
    y1: 0.283,
    x2: -0.1,
    y2: 1.283,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00917d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00917d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6238",
    "data-name": "Group 6238",
    transform: "translate(-594.166 -847.089)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6231",
    "data-name": "Group 6231",
    transform: "translate(594.166 847.089)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6228",
    "data-name": "Group 6228",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6227",
    "data-name": "Group 6227",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16980",
    "data-name": "Path 16980",
    d: "M79.912,4.117c-4.187,0-8.527-3.881-8.57-3.92a.757.757,0,0,0-1.016,0c-.043.039-4.371,3.92-8.57,3.92A.756.756,0,0,0,61,4.873v9.06c0,7.339,5.459,10.272,9.564,11.839a.757.757,0,0,0,.54,0c5.757-2.2,9.564-5.626,9.564-11.839V4.873A.756.756,0,0,0,79.912,4.117Z",
    transform: "translate(-61 0)",
    fill: "url(#linear-gradient)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6233",
    "data-name": "Group 6233",
    transform: "translate(608.77 857.652) rotate(135)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_763",
    "data-name": "Rectangle 763",
    width: 4.546,
    height: 1.093,
    rx: 0.547,
    transform: "matrix(0.015, -1, 1, 0.015, 7.542, 4.702)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_764",
    "data-name": "Rectangle 764",
    width: 1.093,
    height: 8.646,
    rx: 0.547,
    transform: "matrix(0.015, -1, 1, 0.015, 0, 1.093)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecured);
export default __webpack_public_path__ + "static/media/secured.b928d355f8c481998f057948bc4bcc6c.svg";
export { ForwardRef as ReactComponent };